import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/Service/Common.service';
import { ElementLinkService } from 'src/app/Service/element-link/element-link.service';
import { ElementsService } from 'src/app/Service/elements/elements.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { ElementLinkModel } from 'src/app/ViewModel/ElementLinkModel';
import { IElementsViewModel } from 'src/app/ViewModel/ElementsModel';
import { ModuleModel } from 'src/app/ViewModel/ModuleModel';


@Component({
	selector: 'app-add-static-element-link-dialog',
	templateUrl: './add-static-element-link-dialog.component.html',
	styleUrls: ['./add-static-element-link-dialog.component.css']
})
export class AddStaticElementLinkDialogComponent implements OnInit {
	isCreate: boolean;

	isChangesDone = false;
	moduleList!: ReadonlyArray<ModuleModel>;
	selectedModuleId: any;
	elementsList!: ReadonlyArray<IElementsViewModel>;
	selectedElementId: any;
	formGroup!: FormGroup;
	selectedModuleClear = 'N';
	selectedElementClear = 'N';
	isDocSetConfigured:boolean = false;

	constructor(@Inject(MAT_DIALOG_DATA) public data: { isCreate: boolean, dataItem: ElementLinkModel, businessGroupId: number },
		public dialogRef: MatDialogRef<AddStaticElementLinkDialogComponent>,
		public elementService: ElementsService,
		public elementLinkService: ElementLinkService,
		public commonService: CommonService,
		private notificationService: NotificationService,) {
		this.setFormDefaultValues();
		this.isCreate = this.data.isCreate;
	}

	ngOnInit() {
		this.callApis();
	}


	async callApis() {
		if (!this.data.isCreate) {
			this.setFormValues();
		}
		this.moduleList = await this.elementLinkService.getModuleList(this.data.businessGroupId).toPromise();
		let elementListRes:any = await this.elementService.GetElementsList(0).toPromise();
		this.elementsList = elementListRes.filter((eachElement: { is_Active: any; }) => eachElement.is_Active);
	}


	setFormDefaultValues() {
		this.formGroup = new FormGroup({
			defaultValue: new FormControl(''),
			projectElementDescription: new FormControl(''),
			isVisible: new FormControl(false),
			isMandatory: new FormControl(false),
			isDefaultSelect: new FormControl(false),
			isActive: new FormControl(true),
		});
	}


	setFormValues() {
		this.formGroup.get('defaultValue')?.setValue(this.data.dataItem.defaultValue);
		this.formGroup.get('projectElementDescription')?.setValue(this.data.dataItem.projectElementDescription);
		this.formGroup.get('isVisible')?.setValue(this.data.dataItem.isVisible);
		this.formGroup.get('isMandatory')?.setValue(this.data.dataItem.isMandatory);
		this.formGroup.get('isDefaultSelect')?.setValue(this.data.dataItem.isDefaultSelect);
		this.formGroup.get('isActive')?.setValue(this.data.dataItem.isActive);

		this.selectedModuleId = this.data.dataItem.moduleId;
		this.selectedElementId = this.data.dataItem.elementId;
	}

	changeModuleList(event: EIPAutoCompleteEventModel<ModuleModel>) {
		if (event.value != '-2') {
			this.selectedModuleId = event.value;
		} else {
			this.selectedModuleId = null;
		}
	}

	changeElementList(event: EIPAutoCompleteEventModel<IElementsViewModel>) {
		if (event.value != '-2') {
			this.selectedElementId = event.value;
			this.isDocSetConfigured = (this.selectedElementId == 43) ? true : false;
		} else {
			this.selectedElementId = null;
		}
	}

	clearValues() {
		if (this.isCreate) {
			this.selectedModuleClear = 'Y';
			this.selectedElementClear = 'Y';
		}
		this.setFormDefaultValues();
	}

	closeDialog() {
		this.dialogRef.close({ 'isChangesDone': this.isChangesDone });
	}

	saveStaticElementLink() {


		if (!this.selectedModuleId) {
			this.notificationService.showToast('Select Module', 'Warning');
			return;
		}

		if (!this.selectedElementId) {
			this.notificationService.showToast('Select Element', 'Warning');
			return;
		}

		let newStaticElementLink: ElementLinkModel = {
			"defaultValue": !!this.getFormGroupValue('defaultValue') ? this.getFormGroupValue('defaultValue') : null,
			"elementId": this.selectedElementId,
			"groupId": this.data.businessGroupId,
			"isActive": this.getFormGroupValue('isActive'),
			"isDefaultSelect": this.getFormGroupValue('isDefaultSelect'),
			"isMandatory": this.isDocSetConfigured ? this.getFormGroupValue('isVisible') : this.getFormGroupValue('isMandatory'),
			"isVisible": this.getFormGroupValue('isVisible'),
			"moduleId": this.selectedModuleId,
			"projectElementDescription": !!this.getFormGroupValue('projectElementDescription') ? this.getFormGroupValue('projectElementDescription') : null,
			"projectId": Number(this.commonService.getProjectId()),
			"sortBy": 0,
			"isNumbering": false,
			"hasDependency": false,
			"isSerialNumber": false,
			"elementHierarchy": 0,
			"moduleDescription": null,
			"elementDescription": null,
			"dependentElementId": 0,
			"dependentElementDescription": null,
			"isShowListPage": false,
			"isMemberAccess": false
		}

		let reqData = {
			"isQueryForStaticElement": true,
			"createdBy": this.commonService.getLoggedInUserId(),
			"elementLinkDetails": [newStaticElementLink],
		};

		this.elementLinkService.saveDocumentElements(reqData).subscribe((data:any) => {
			this.isChangesDone = true;
			if(data.successCode == 200)
			{
			this.clearValues();
			this.notificationService.handleResponse(data);
			this.closeDialog();
			}
			else
			{
				this.notificationService.handleResponse(data);
			}
		});
	}

	/**
	 * Get Form group value by key
	 * @param keyName
	 */
	getFormGroupValue = (keyName: string): any => this.formGroup.get(keyName)?.value;
}
